module.exports = __webpack_public_path__ + "static/media/g-5-d.62e0ebfc.jpg";